import { render, staticRenderFns } from "./toorder.vue?vue&type=template&id=a2b4f1c4&scoped=true&"
import script from "./toorder.vue?vue&type=script&lang=js&"
export * from "./toorder.vue?vue&type=script&lang=js&"
import style0 from "./toorder.vue?vue&type=style&index=0&id=a2b4f1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b4f1c4",
  null
  
)

export default component.exports